import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import firebase from "firebase/app";

import "./index.css";

const firebaseConfig = {
  apiKey: "AIzaSyB6ISPNHT__DNzbb1bllPi-ubzmasNuZto",
  authDomain: "appodeal-dev.firebaseapp.com",
  databaseURL: "https://appodeal-dev.firebaseio.com",
  projectId: "appodeal-dev",
  storageBucket: "appodeal-dev.appspot.com",
  messagingSenderId: "893254883779",
  appId: "1:893254883779:web:618f08a4b5bf75ec8d8576",
  measurementId: "G-47J9VF218H",
};

firebase.initializeApp(firebaseConfig);

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
